(function () {
  'use strict';

  class AtribuicaoDuoRoutesCtrl {
    constructor(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, $window, blockUI, moment, $state, FeaturehubJsSdk) {
      this.keys = Keys;
      this.moment = moment;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.window = $window;
      this.blockUI = blockUI;
      this.state = $state;
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.filtro = null;
      this.user = null;

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([
          {
            name: 'uoId',
            key: this.keys.uo.name
          },
          {
            key: this.keys.dateTime.name,
            time: true,
            maxDate: this.moment().endOf('day').format(),
            defaultValues: {
              hoje: {
                active: true
              },
              ontem: {
                active: true
              }
            }
          },
          {
            name: 'veiculosId',
            key: this.keys.veiculos.name,
            ignoreValidation: true
          }
        ])
      ).then((filtro) => {
        this.filtro = filtro;
      });
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './DuoRouteAssignmentListPageRoute',
          componentId = 'safety-duo-route-assignment-list',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    goToRouteAssignmentForm() {
      this.state.go('root.duo-routes-atribuicao.form');
    }

    goToVehicle(vehicleId) {
      let uoId = this.filtro.find((f) => f.key === this.keys.uo.name).value.id;
      const link = `mapas-grid?vfiltro=uo:${uoId};veiculos:${vehicleId}`;

      this.window.open(link, '_blank');
    }

    goToAssignmentExecutionDetails(assignmentUUID) {
      if (!this.featurehubJsSdk.isFeatureEnabled('LADRX-336-assignment-details')) {
        return;
      }
      this.state.go('root.duo-routes-atribuicao.details', {UUID: assignmentUUID});
    }

    getReactProps() {
      const filteredVehicles = this.filtro.find((f) => f.key === this.keys.veiculos.name);
      return {
        user: this.user,
        filter: {
          ouId: this.filtro.find((f) => f.key === this.keys.uo.name).value.id,
          startDate: this.filtro.find((f) => f.key === this.keys.dateTime.name).value.startDate,
          endDate: this.filtro.find((f) => f.key === this.keys.dateTime.name).value.endDate,
          vehicleIds: filteredVehicles ? filteredVehicles.values.map((v) => v.id) : []
        },
        goToRouteAssignmentForm: () => this.goToRouteAssignmentForm(),
        goToVehicle: (id) => this.goToVehicle(id),
        goToAssignmentExecutionDetails: (assignmentUUID) => this.goToAssignmentExecutionDetails(assignmentUUID)
      };
    }

  }

  angular
    .module('duo-routes.atribuicao-rotas')
    .controller('AtribuicaoDuoRoutesCtrl', AtribuicaoDuoRoutesCtrl);
}());
